import Swiper, { Lazy, Autoplay } from 'swiper';

Swiper.use([Lazy, Autoplay]);

const awardspotlight = document.querySelectorAll('[data-js=awardspotlight]');

for (let i = awardspotlight.length - 1; i >= 0; i -= 1) {
	const sliderEl = awardspotlight[i].querySelector(
		'[data-js=awardspotlight-carousel]'
	);
	const timeOut = sliderEl.getAttribute('data-timeout-js');

	// eslint-disable-next-line no-new
	new Swiper(sliderEl, {
		direction: 'vertical',
		effect: 'slide',
		slidesPerView: 1,
		autoHeight: true,
		loop: true,
		autoplay: {
			delay: timeOut,
			disableOnInteraction: false,
		},
	});
}
